import { ApiClient } from '@/shared/api/client';
import type { TicketDetail, TicketListResponse } from '@/features/ai-dart/types';

export const UNATTRIBUTED_REPO = '-';
export const TICKET_POLL_MS = 15_000;

export const ticketsApi = {
  /** 값은 URL 쿼리 그대로 넘긴다 — 필터의 정본이 화면의 URL이라 여기서 다른 어휘로 옮기지 않는다. */
  list(filters: { status?: string; severity?: string; repo?: string; q?: string; hideClosed?: string; sort?: string }): Promise<TicketListResponse> {
    const query = new URLSearchParams(Object.entries(filters).filter((entry): entry is [string, string] => Boolean(entry[1])));
    return ApiClient.getJson(`/ai-dart/tickets${query.size ? `?${query}` : ''}`);
  },
  detail(id: number): Promise<TicketDetail> { return ApiClient.getJson(`/ai-dart/tickets/${id}`); },
  /** 첨부 이미지는 JSON이 아니라 바이트라 `<img>`가 직접 부른다 — 경로 규약을 여기 한 곳에 둔다. */
  imageSrc(id: number, index: number): string { return ApiClient.assetUrl(`/ai-dart/tickets/${id}/images/${index}`); },
  act(id: number, input: { action: 'reopen' | 'close' | 'attribute'; resolution?: string; repo?: string }): Promise<{ ok: true; repo?: string; auto?: 'allow' | 'deny' }> {
    return ApiClient.patchJson(`/ai-dart/tickets/${id}`, input);
  },
  dispatch(id: number): Promise<{ ok: true }> { return ApiClient.postJson(`/ai-dart/tickets/${id}/dispatch`); },
};
